import {defAction} from "../../../../helpers/defaultAction"
import {reZoneConstants} from "./constants"
import api from './api'

export const reZoneActions = {
    getList,
    clearZones
}

function getList(values) {
    const dispatchObj = {
        constants: reZoneConstants.GetZones,
        service: {
            func: api.getZones,
            params: values
        }
    }
    return defAction(dispatchObj)
}

function clearZones() {
    return (dispatch) => dispatch({type: reZoneConstants.ClearZones})
}